module.exports = __webpack_public_path__ + "static/needy-2368ee4836eaede5aba5a0911b5a2d8e.jpg";